import React from "react";
import EmojiAndProgressbar from "./EmojiAndProgressbar";
import CheckInStatsDetailCardPerUser from "./CheckInStatsDetailCardPerUser";
import ProgressBar from "components/Progressbar";

const checkInpercentage = {
  paddingLeft: "3px",
  color: "white",
  fontSize: "12px",
  paddingTop: "4px",
};

const CheckInStatsDetailCard = ({ checkstats }) => {
  return checkstats.length !== 0 ? (
    <div style={{ marginRight: "3px" }}>
      <div class="happiness-meter">
        <div class="color-white">Overall team happiness meter</div>
        <h6 class="orange-clr">
          <strong>{`${checkstats.metrics_meter.meter}%     Good Mood`}</strong>
        </h6>
        <ProgressBar
          completed={checkstats.metrics_meter.meter}
          progressBackgroundColor="#e0e0de"
          bgcolor={"#FFA100"}
        />
        <EmojiAndProgressbar
          checkstats={checkstats.metrics_meter.moods}
          bgcolor={"white"}
          classPercentage={checkInpercentage}
        />
      </div>
      {checkstats.users.map((users) => (
        <CheckInStatsDetailCardPerUser key={users.id} userStats={users} />
      ))}
    </div>
  ) : null;
};

export default CheckInStatsDetailCard;
